<section id="main">
    <div class="container-fluid cards-overview">
         <div class="row m-0">
            <div class="col-md-12">
              <h2>
                <h2 class="f-28" translate="cards.allCardsOverview"></h2>
              </h2>
            </div>
          </div>
        <div class="row m-0 m-b-15">
            <div ng-if="vm.cards.length">
                <div class="m-b-15 col-md-6" ng-repeat="card in vm.cards" 
                     data-ng-click="vm.goToCard(card)">
                     <card-widget card="card"></card-widget>
                </div>
            </div>
        </div>
    </div>
</section>